import React, { useState } from "react";
import { Link } from "react-router-dom";
import BillingIcon from "../../../assets/icons/nav_billing.svg2";
import UsergroupIcon from "../../../assets/icons/user_group.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function BillingWidget() {
  const [billing, setBilling] = useState(3800);
  const [date, setDate] = useState("23/03/2024(20 days)");
  const [period, setPeriod] = useState("week");

  return (
    <div className=" h-100 p-3 text-white rounded-3">
      <div className="card-body d-flex flex-column justify-content-between">
        <div className="widget-header">
          <BillingIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold"> BILLING</span>
          <HelpButton helpKey="widget-billing" iconClassName="white" />
        </div>
        <NewFeature>
          <hr className="text-white my-2" />
          <div className="text-center">
            <h1 className="fw-bold display-4 m-0">£{billing}</h1>
            <div className="opacity-50 small">Lorem ipsum dolor sit amet.</div>
            <div className="fs-6 fw-bold text-white mt-2">
              Next invoice due:
            </div>
            <div className="opacity-50 small">{date}-Pay Now</div>
          </div>
          <div className="text-center   ">
            <hr className="text-white my-2" />
            <button
              type="button"
              className={`btn btn-light  px-3 py-0 rounded-pill text-purple text-xs fw-bold mx-1 ${
                period === "today" ? "" : "opacity-50"
              }`}
              onClick={() => setPeriod("today")}
            >
              DAY
            </button>
            <button
              type="button"
              className={`btn btn-light  px-3 py-0 rounded-pill text-purple text-xs fw-bold mx-1 ${
                period === "week" ? "" : "opacity-50"
              }`}
              onClick={() => setPeriod("week")}
            >
              WEEK
            </button>
            <button
              type="button"
              className={`btn btn-light  px-3 py-0 rounded-pill text-purple text-xs fw-bold mx-1 ${
                period === "month" ? "" : "opacity-50"
              }`}
              onClick={() => setPeriod("month")}
            >
              MONTH
            </button>
          </div>
        </NewFeature>
      </div>
    </div>
  );
}
